import Litepicker from 'litepicker';

export function init() {
    const checkInField = document.querySelector('.js-date-check-in'),
        checkOutField = document.querySelector('.js-date-check-out');

    let litePickerCheckIn = new Litepicker({
        element: checkInField,
        format: 'DD/MM/YYYY',
        minDate: new Date(),
        setup: (picker) => {
            picker.on('selected', (startDate) => {
                let tomorrow = startDate.setDate(startDate.getDate() + 1);

                litePickerCheckOut.setOptions({
                    minDate: tomorrow
                });
            });
        }
    });
    
    let litePickerCheckOut = new Litepicker({
        element: checkOutField,
        format: 'DD/MM/YYYY',
        minDate: new Date(),
    });
}